import { ENV_CONFIG } from '../config/environment';

const SESSION_KEY = ENV_CONFIG.COMPANY_SESSION_KEY || 'planillas_company_session';
const LEGACY_KEY = ENV_CONFIG.COMPANY_KEY;
const FORCE_SELECTOR_KEY = 'planillas_force_company_selector';

function lastCompanyKey(userId) {
  return `planillas_company_last_${userId}`;
}

function safeParse(json) {
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function readSessionCompany() {
  try {
    return safeParse(sessionStorage.getItem(SESSION_KEY));
  } catch {
    return null;
  }
}

function readLegacyCompany() {
  try {
    return safeParse(localStorage.getItem(LEGACY_KEY));
  } catch {
    return null;
  }
}

function consumeForceSelectorFlag() {
  try {
    if (sessionStorage.getItem(FORCE_SELECTOR_KEY) === '1') {
      sessionStorage.removeItem(FORCE_SELECTOR_KEY);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/**
 * Empresa activa en esta pestaña (sessionStorage).
 * Si no hay, usa la última empresa del usuario como sugerencia inicial.
 */
export function getSelectedCompany(userId = null) {
  if (consumeForceSelectorFlag()) {
    return null;
  }

  const fromSession = readSessionCompany();
  if (fromSession?.id) {
    return fromSession;
  }

  if (userId) {
    try {
      const last = safeParse(localStorage.getItem(lastCompanyKey(userId)));
      if (last?.id) {
        return last;
      }
    } catch {
      /* ignore */
    }
  }

  const legacy = readLegacyCompany();
  if (legacy?.id) {
    setSelectedCompany(legacy, userId);
    return legacy;
  }

  return null;
}

/** Guarda la empresa solo en esta pestaña (+ respaldo de última empresa del usuario). */
export function setSelectedCompany(company, userId = null) {
  try {
    if (company?.id) {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(company));
      if (userId) {
        localStorage.setItem(lastCompanyKey(userId), JSON.stringify(company));
      }
    } else {
      sessionStorage.removeItem(SESSION_KEY);
    }
  } catch {
    /* ignore */
  }

  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    /* ignore */
  }
}

/** Quita la empresa de la pestaña actual y fuerza el selector al recargar. */
export function prepareCompanyChange() {
  clearSessionCompany();
  try {
    sessionStorage.setItem(FORCE_SELECTOR_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function isForcingCompanySelector() {
  try {
    return sessionStorage.getItem(FORCE_SELECTOR_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearForceCompanySelector() {
  try {
    sessionStorage.removeItem(FORCE_SELECTOR_KEY);
  } catch {
    /* ignore */
  }
}

/** Quita la empresa de la pestaña actual (p. ej. cambiar de empresa). */
export function clearSessionCompany() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Limpia empresa en logout (pestaña + claves globales). */
export function clearAllCompanyStorage(userId = null) {
  clearSessionCompany();
  try {
    localStorage.removeItem(LEGACY_KEY);
    if (userId) {
      localStorage.removeItem(lastCompanyKey(userId));
    }
  } catch {
    /* ignore */
  }
}
